/**
* 系统管理  提现订单管理
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>提现订单管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="queryParams" class="user-search">
      <el-form-item label="搜索：">
        <el-select size="small" v-model="queryParams.lx" placeholder="请选择类型">
          <el-option v-for="x in lxList" :label="x.dictLabel" :value="x.dictValue" :key="x.dictValue"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="queryParams.orgName" placeholder="输入渠道名称"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
<!--        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>-->
        <!--        <el-button size="small" type="primary" @click="handleunit()">部门设置</el-button>-->
      </el-form-item>
    </el-form>

    <!--列表-->
    <el-table size="small" :data="dataList" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column label="序号" align="center" type="index" :index="indexMethod" width="60"/>
      <el-table-column prop="xm" label="姓名"/>
      <el-table-column prop="orgName" label="渠道名称"/>
      <el-table-column prop="dzPrice" label="到账金额"/>
      <el-table-column prop="sxf" label="手续费"/>
      <el-table-column prop="txPrice" label="提现金额"/>
      <el-table-column prop="zfbAccount" label="支付宝账号"/>
      <el-table-column prop="upAccount" label="银联账号"/>
      <el-table-column prop="khh" label="开户行"/>
      <el-table-column prop="khhXm" label="开户人姓名"/>
      <el-table-column prop="createTime" label="申请时间" width="140"/>
      <el-table-column prop="fjUurl" label="附件"/>
      <el-table-column prop="ztMc" label="状态"/>

      <el-table-column align="center"  label="操作" width="100">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            content="处理"
            placement="top"
          >
            <el-button
              size="mini"
              icon="el-icon-s-check"
              @click="handleEdit(scope.$index, scope.row)"
            >
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>


    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormShow" width="30%" :close-on-click-modal="false" @click='closeDialog("edit")'>
      <el-form label-width="100px" ref="form" :model="form" :rules="rules">
        <el-form-item label="审核结果" prop="zt">
          <el-select size="small" style="width: 100%" clearable v-model="form.zt" placeholder="请选择审核结果">
            <el-option
              v-for="x in ztList"
              :label="x.dictLabel"
              :value="x.dictValue"
              :key="x.dictValue">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="附件" prop="fjUrl">
          <el-upload
            style="display: inline-block; margin-right: 10px;"
            ref="upload"
            class="upload-demo"
            accept=".jpg,.png"
            :action="url"
            :on-success="uploadFileAll"
            :before-upload="beforeAvatarUpload"
            :on-exceed="handleExceed"
            :limit="1">
            <el-button size="small" type="primary">上传文件</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="备注" prop="bz">
          <el-input size="small" type="textarea" :rows="3" maxLength="200" v-model="form.bz" placeholder="请输入备注"></el-input>
        </el-form-item>

      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('form')">保存</el-button>
      </div>
    </el-dialog>



  </div>
</template>

<script>
import Pagination from "../../components/Pagination.vue";
import {
  deleteOrg,
  queryAllTxList,
  queryOrgDetail,
  queryOrgList,
  removeUser,
  saveOrg,
  updateOrg, updateTxInfo
} from "../../api/userMG";
import {formatInportData} from "../../utils/util";

export default {
  name: "CashOrder",
  components: {Pagination},
  data() {
    return {
      loading: false, //是显示加载
      title: '处理',
      editFormShow: false, //控制编辑页面显示与隐藏

      dataList: [],
      queryParams: {
        page: 1,
        size: 10
      },
      // 编辑与添加
      form: {},
      // rules表单验证
      rules: {
        zt: [
          { required: true, message: '请选择审核结果', trigger: 'blur' }
        ],
      },

      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },

      // 上传参数
      url: '/api/common/upload',

      lxList: [
        { dictLabel: '支付宝', dictValue: 1 },
        { dictLabel: '银行账户', dictValue: 2 },
      ],
      ztList: [
        { dictLabel: '完成', dictValue: 1 },
        { dictLabel: '退回', dictValue: 2 },
      ],
    }
  },

  created() {
    this.initDate()
  },

  methods: {
    formatInportData,
    initDate() {
      this.getdata()
    },
    indexMethod(index) {
      return (this.pageparm.currentPage - 1) * this.pageparm.pageSize + index + 1;
    },

    // 获取数据方法
    getdata() {
      this.loading = true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      // 获取用户列表
      queryAllTxList(this.queryParams).then(res => {
        this.loading = false
        if (res.code != 200) {
          this.$message({
            type: 'info',
            message: res.msg
          })
        } else {
          this.dataList = res.data.content
          // 分页赋值
          this.pageparm = res.data.pageparm
        }
      })
        .catch(err => {
          this.loading = false
          this.$message.error('加载失败，请稍后再试！')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.queryParams.page = parm.currentPage
      this.queryParams.size = parm.pageSize
      this.getdata()
    },
    //搜索事件
    search() {
      /*if (this.queryParams.query.areaCode) {
        this.queryParams.query.areaCode = this.queryParams.query.areaCode[this.queryParams.query.areaCode.length - 1]
      }*/
      this.getdata()
    },

    // 上传 全部图片成功回调
    uploadFileAll(res, file) {
      this.form.fjUrl = res.data.url;
    },
    handleExceed(files, fileList) {
      this.$message.warning(`请先删除已上传的文件后，在进行新文件上传！`);
    },
    beforeAvatarUpload(file) {
      var isJPG = false;
      if (file.type === 'image/png' || file.type === 'image/jpeg') {
        isJPG = true;
      }
      // const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('上传的附件只能是 JPG 或 PNG 格式!');
      }
      // if (!isLt2M) {
      //   this.$message.error('上传头像图片大小不能超过 2MB!');
      // }
      // return isJPG && isLt2M;
      return isJPG;
    },

    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormShow = true
      this.title = '处理'
      this.form.id = JSON.parse(JSON.stringify(row)).id;
    },
    // 编辑、添加提交方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          // 处理
          updateTxInfo(this.form).then(res => {
            this.editFormShow = false
            this.loading = false
            if (res.code == 200) {
              this.getdata()
              this.form = {}
              this.$message({
                type: 'success',
                message: '处理成功！'
              })
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
            .catch(err => {
              this.editFormShow = false
              this.loading = false
              this.$message.error('处理失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    // 关闭编辑、增加弹出框
    closeDialog(dialog) {
      if (dialog == 'edit') {
        this.form = {};
        this.editFormShow = false
      }
    },

  }

}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/system/cashOrder.vue